import React from "react";
import { NewReportPreviewTable } from "../../../news/components/NewReportPreviewTable/NewReportPreviewTable";
import { NewReportPreviewFilter } from "../../../news/components/NewReportPreviewFilter/NewReportPreviewFilter";
import { useNewsPreviewTab } from "./useNewsPreviewTab";
import { ResourceTab } from "../../../../shared/components/layout/ResourceTab";
import { ConfirmationModal } from "../../../../shared/components/ui/ConfirmationModal";

export const NewsPreviewTab: React.FC<ReturnType<typeof useNewsPreviewTab>> = (
  props
) => {
  const {
    newsReportPreviewResource,
    buildingOptions,
    reportTypeOptions,
    handleEditNew,
    isDeleteModalOpen,
    isDeletingNew,
    handleOpenDeleteModal,
    handleCloseDeleteModal,
    handleConfirmDelete,
  } = props;

  return (
    <>
      <ResourceTab
        resource={newsReportPreviewResource}
        filtersComponent={
          <NewReportPreviewFilter
            lifeguardName={newsReportPreviewResource.filters.lifeguard_name}
            buildingId={newsReportPreviewResource.filters.building_id}
            reportTypeId={newsReportPreviewResource.filters.report_type_id}
            startDate={newsReportPreviewResource.filters.start_date}
            endDate={newsReportPreviewResource.filters.end_date}
            buildingOptions={buildingOptions}
            reportTypeOptions={reportTypeOptions}
            onLifeguardNameChange={(v) =>
              newsReportPreviewResource.handleFilterChange("lifeguard_name", v)
            }
            onBuildingIdChange={(v) =>
              newsReportPreviewResource.handleFilterChange("building_id", v)
            }
            onReportTypeIdChange={(v) =>
              newsReportPreviewResource.handleFilterChange("report_type_id", v)
            }
            onStartDateChange={(v) =>
              newsReportPreviewResource.handleFilterChange("start_date", v)
            }
            onEndDateChange={(v) =>
              newsReportPreviewResource.handleFilterChange("end_date", v)
            }
            onApplyFilters={newsReportPreviewResource.applyFilters}
            onClearFilters={newsReportPreviewResource.resetFilters}
            onRefresh={newsReportPreviewResource.refetch}
            isRefreshing={newsReportPreviewResource.isFetching}
          />
        }
        tableComponent={
          <NewReportPreviewTable
            newsData={newsReportPreviewResource.data!}
            isLoading={newsReportPreviewResource.isLoading}
            isError={newsReportPreviewResource.isError}
            page={newsReportPreviewResource.page}
            pageSize={newsReportPreviewResource.pageSize}
            onPageChange={newsReportPreviewResource.handlePageChange}
            onPageSizeChange={newsReportPreviewResource.handlePageSizeChange}
            onEditNew={handleEditNew}
            onDeleteNew={handleOpenDeleteModal}
            isDeletingNew={isDeletingNew}
            showCellBorders
          />
        }
        emptyStateMessage="No hay novedades para mostrar."
      />

      {/* Delete Confirmation Modal */}
      <ConfirmationModal
        open={isDeleteModalOpen}
        onClose={handleCloseDeleteModal}
        onConfirm={handleConfirmDelete}
        title="Eliminar Novedad"
        message="¿Está seguro que desea eliminar esta novedad? Esta acción no se puede deshacer."
        confirmText="Eliminar"
        cancelText="Cancelar"
        isLoading={isDeletingNew}
        variant="danger"
      />
    </>
  );
};